<template>
  <v-flex xs12 sm5>
    <v-layout row column>
      <v-card v-if="this.enabled" class="mb-3">
        <a :href="this.promotion_link || '#'">
          <v-img
              :src="promotion_url"
              max-height="200"
              contain
          />
        </a>
      </v-card>
      <v-card>
        <v-toolbar card dense color="success">
          <v-toolbar-title class="white--text">{{ 'app.pages.home.create_menu_header' | trans }}</v-toolbar-title>
        </v-toolbar>
        <v-responsive>
          <div class="mt-2">
            <iframe width="100%" height="315"
                    src="https://www.youtube.com/embed/Ose049DSJcM?rel=0&amp;showinfo=0" frameborder="0"
                    allow="autoplay; encrypted-media" allowfullscreen></iframe>
          </div>
        </v-responsive>
        <v-card-actions>
          <v-btn href="https://www.youtube.com/channel/UCGTvrZ7KOV1kS5uaQ9qZWsA/videos" class="ml-2" color="success">
            <v-icon left>play_circle_filled</v-icon>
            {{ 'app.pages.home.check_other_tutorials' | trans }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  data: function () {
    return {
      promotion_url: null,
      promotion_link: null,
      enabled: false
    };
  },
  props: {
    promotion: {
      type: String,
      required: false
    }
  },
  mounted() {
    if (this.promotion !== null) {
      const promotion = JSON.parse(this.promotion);
      this.enabled = promotion.enabled;
      this.promotion_url = `/storage/promo/${promotion.image}`;
      if (promotion.url) {
        this.promotion_link = promotion.url;
      }
    }
  }
}
</script>
